import { render, staticRenderFns } from "./ListaAgenda.vue?vue&type=template&id=3d0c0528&"
import script from "./ListaAgenda.vue?vue&type=script&lang=js&"
export * from "./ListaAgenda.vue?vue&type=script&lang=js&"
import style0 from "./ListaAgenda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports